<template>
  <div style="width: 100vw;">
    <!--   合作伙伴 partner  -->

    <!-- img_normal_img_cooperate_ph -->
    <img
      v-if="ISphone"
      src="http://pic.midongtech.xyz/yytgw/assets/img_normal_img_cooperate_ph.png"
      style="width: 100vw;"
    />
    <div v-else class="partner fx-column fx-row-center">
      <div
        :class="ISphone ? smallh1label : bigh1label"
        style="margin-top: 5vw; color: white;"
      >我们的合作伙伴</div>
      <div class="blueline"></div>
      <img
        src="http://pic.midongtech.xyz/yytgw/assets/img_common_img_coopera_worker.png"
        style="width: 67vw;height: 55vw;margin-top: 5vw; margin-bottom: 5vw;"
      />
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  name: "partner",
  data() {
    return {
      ISphone: false,

      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label"
    };
  },
  mounted() {
    //可用于设置自适应屏幕，根据获得的可视宽度（兼容性）判断是否显示
    let w = document.documentElement.offsetWidth || document.body.offsetWidth;
    if (w < 1000) {
      this.ISphone = true;
    }

    // this.ISphone = this.$appdata.ISphone;
    //      ISphone: false,
    //   this.ISphone = this.$appdata.ISphone;
  },
  methods: {
    /**
     * 点击事件
     */
    /**
     * 网络请求
     */
    /**
     * 业务方法
     */
    /**
     * 回调方法
     */
    /**
     * 页面私有方法
     */
  }
};
</script>
<style lang="less" scoped>
/*页面公共样式*/

/*  <!--   合作伙伴 partner  --> */
.partner {
  width: 100vw;
  /*height: 83vw;*/
  background: #16214b;
}

/*头部*/

/*列表*/
</style>
